import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
`<template>
<style>
  .legends .dateTypeIndicator.circle {
    padding-top: 5px;
    align-items: center;
  }

  .legends {
    display: flex;
    flex-direction: var(--com-calendar-legends-flex-direction);
    margin: 0px 8px 20px 8px;
    flex-wrap: wrap;
    row-gap: 8px;
  }

  .legends.sameLine {
    flex-direction: row;
  }

  .legends .dateTypeIndicator.primary,
  .legends .dateTypeIndicator.all {
    image-rendering: -webkit-optimize-contrast;
  }

  .legends .dateTypeIndicator.primary img,
  .legends .dateTypeIndicator.all img {
    width: var(--com-calendar-legend-indicator-img-width, 10px);
  }

  .legends .dateTypeIndicator.primary svg,
  .legends .dateTypeIndicator.all svg {
    width: var(--com-calendar-legend-indicator-svg-width, 10px);
  }
                      
  .legends .dateTypeIndicatorIcon.no-reservations {
    font-size: var(--com-calendar-legend-no-reservation-icon-font-size, 10px);
  }

  .legendItem {
    display: flex;
    align-items: baseline;
  }

  .legendItem.gtg {
    align-items: center;
  }

  .legendItem.gtg .legendDisplayName {
    margin-right: 0;
  }

  .legendItem com-icon,
  .legendItem div {
    margin-right: var(--com-calendar-legend-icon-margin-right, 10px);
  }

  .legendItem .dateTypeIndicator.unavailable {
    margin-top: 0px;
    margin-bottom: auto;
    align-self: center;
  }

  .legendDisplayName {
    color: #00233C;
  }

  .legendItem div.legendDisplayName {
    margin-right: 20px;
  }

  .legendItem div.legendDisplayName.prices {
    color: var(--com-calendar-prices-legend-color, var(--message-grey));
  }

  .legendItem .overlapping {
    padding-right: var(--com-calendar-legend-overlapping-padding-right, 0);
  }
</style>
</template>`;

styleElement.register('com-calendar-legend-style');